PJQ.views.addressbook.AddressBookDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Results Available"
        },
        isHideSearch: true,
        dom: '<"top"p<"clear">>rt<"bottom"p<"clear">>',
        phoneWidth: '125px'
    },
    events: {
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail'
    },
    beforeDataTableRender: function () {
        let self = this;
        this.options.rowCallback = function (row, data) {
            if (data.get('isBlacklisted') || (data.get('isCompanyBlacklisted') && data.get('contactCompanyId') === data.get('contactId'))) {
                $(row).find('td').css('text-decoration', 'line-through');
            }

            if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'addressBook')) {
                let abCustomization = PJQ.app.portal.customization.addressBook;
                if (typeof abCustomization.getRowColor === 'function') {
                    try {
                        let color = abCustomization.getRowColor(self.options.settings.view, data, {
                            companyCustomFields: PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')],
                            contactCustomFields: PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')]
                        });
                        if (_.size(color) > 0) {
                            $(row).css('background-color', color);
                        }
                    } catch {
                        //do nothing, we just dont want an error to happen due to code customizations
                    }
                }
            }
        };

        this.options.afterDataTableRender = _.bind(function () {
            this.$el.on('draw.dt', _.bind(function () {
                this.$el.find('div.pretty input.indeterminate').prop('indeterminate', true);
            }, this));
        }, this);

        this.options.childDataTables = [];

        // This is here to wrap the table in case of overflow. ScrollX option for datatables is bad.
        this.options.initComplete = function (settings, json) {
            this.wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
        }

        this.options.contextMenuOptions = {
            actions: this.getContextMenuItems(),
            isHideNoActions: true
        };

        this.options.onRowDoubleClick = _.bind(function (row) {
            if (row.data() && row.data().get('contactId')) {
                this.editContact(row.data());
            }
        }, this);

        if (this.options.settings) {
            // enable paging for grids that have a setting for it / are not subgrids
            if (this.options.settings.rowsPerPage !== 0 && this.options.view.indexOf('-') === -1)
                this.options.pageLength = this.options.settings.rowsPerPage;
            else
                this.options.pageLength = 2147483646;

            if (this.options.settings.orderBy !== 'sortOrder') {
                if (_.size(this.options.settings.columns) === 0) {
                    this.options.settings.orderBy = this.options.settings.columnsDefault[0];
                } else if (this.options.settings.columns.indexOf(this.options.settings.orderBy) === -1) {
                    this.options.settings.orderBy = this.options.settings.columns[0];
                }
            }
            _.each(this.getColumns(false, this.options.view), _.bind(function (column, index) {
                if (column.columnData === this.options.settings.orderBy) {
                    this.options.order = [[index, this.options.settings.orderAscending ? 'asc' : 'desc']];
                }
            }, this));

            /* 2025-09-23 Blue: moved because needed values aren't in scope
            *
            let fixedColumnsLeft = 0;
            switch (this.options.settings.view) {
                case PJQ.constants.addressBook.view.TRADES_COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP:
                case PJQ.constants.addressBook.view.TRADES_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP:
                case PJQ.constants.addressBook.view.CONTACT_GROUP:
                    fixedColumnsLeft = 1;

                    break;
                case PJQ.constants.addressBook.view.COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY:
                    fixedColumnsLeft = this.options.isShowCheckboxes ? 2 : 1;
   
                    break;
                case PJQ.constants.addressBook.view.CONTACT:
                case PJQ.constants.addressBook.view.COMPANY_CONTACT:
                    fixedColumnsLeft = this.options.isShowCheckboxes ? 1 : 0;
                    if (this.options.addressBookView.options.selectionMode == PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                        fixedColumnsLeft++;
                    }

                    break;
                case PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY_CONTACT:
                    fixedColumnsLeft = this.options.isShowCheckboxes ? 1 : 0;

                    break;
                default:
                    break;
            }
            this.options.colReorder = {
                fixedColumnsLeft: fixedColumnsLeft,
                realtime: false
            };
             */
        }

        this.options.createdRow = _.bind(this.createdRow, this);

        if (typeof this.options.beforeDataTableRender === 'function') {
            this.options.beforeDataTableRender();
        }
    },
    columnOrderChanged: function (columns) {
        if (this.options.userSettings != null) {
            /* #311 - error when drag-drop sorting columns.
            let settings = this.options.userSettings.get('settings');
            for (let i = 0; i < _.size(settings); i++) {
                if (settings[i].view === this.options.view) {
                    settings[i].columns = columns;
                }
            }
            this.options.userSettings.set('settings', settings);

             */
            this.options.userSettings.save();
        }
    },
    afterDataTableRenderChild: function () {
    },
    getRowChildTable: function (childOpts) {
    },
    getRowChildData: function (row) {
    },
    setRowStyle: function (row, status, isBlacklisted) {
    },
    getContextMenuItems: function () {
    },
    orderByChanged: function() {
        if (this.options.userSettings != null) {
            let settings = this.options.userSettings.get('settings');
            for(let i = 0 ; i < _.size(settings) ; i++){
                if(settings[i].view === this.options.settings.view){
                    settings[i].orderBy = this.options.settings.orderBy;
                    settings[i].orderAscending = this.options.settings.orderAscending;
                }
            }
            this.options.userSettings.set('settings', settings);
            this.options.userSettings.save();
        }
    },
    renderPageHelper: function() {
        if (this.getIsRootView())
            this.renderPage();
        else {
            //refetch then redraw
            this.options.collection.fetch({
                type: 'POST',
                data: this.options.requestData,
                success: _.bind(function() {
                    this.dataTable.clear();
                    this.dataTable.rows.add(this.options.collection.models);
                    this.dataTable.draw();
                }, this)
            });
        }
    },
    editContact: function (model) {
        let fnFetch = _.bind(function (model, company) {
            let fnEdit = _.bind(function (model, company) {
                if (model.get('isApprovalRequired') && _.size(model.approvalUpdates.models) > 0) {
                    new PJQ.views.addressbook.ApproveAddressBookContactModal({
                        model: model,
                        onSave: _.bind(function (model) {

                            // remove deleted groups
                            model.groups.models = _.filter(model.groups.models, function (group) { return !group.get('isDeleted'); });

                            new PJQ.views.addressbook.EditCompanyModal({
                                model: model,
                                company: company,
                                contactId: model.get('contactCompanyId') > 0 ? model.id : null,
                                contactCompanyId: model.get('contactCompanyId'),
                                onSave: _.bind(function () {
                                    this.renderPageHelper();
                                }, this),
                                onSaveContact: _.bind(function (contact, isNew) {
                                    if (isNew) {
                                        this.options.addressBookView.addSelectedContactsAll([contact.get('contactId')]);
                                        if (_.size(contact.get('contactGroups')) > 0) {
                                            this.options.addressBookView.addSelectedContactGroups(contact.get('contactGroups'));
                                        } else {
                                            this.options.addressBookView.addSelectedContactsNoGroup([contact.get('contactId')]);
                                        }
                                    }
                                }, this),
                                onDelete: _.bind(function () {
                                    this.renderPageHelper();
                                }, this)
                            });
                        }, this)
                    })
                } else {
                    new PJQ.views.addressbook.EditCompanyModal({
                        model: model,
                        company: company,
                        contactId: model.get('contactCompanyId') > 0 ? model.id : null,
                        contactCompanyId: model.get('contactCompanyId'),
                        onSave: _.bind(function () {
                            this.renderPageHelper();
                        }, this),
                        onSaveContact: _.bind(function (contact, isNew) {
                            if (isNew) {
                                this.options.addressBookView.addSelectedContactsAll([contact.get('contactId')]);
                                if (_.size(contact.get('contactGroups')) > 0) {
                                    this.options.addressBookView.addSelectedContactGroups(contact.get('contactGroups'));
                                } else {
                                    this.options.addressBookView.addSelectedContactsNoGroup([contact.get('contactId')]);
                                }
                            }
                        }, this),
                        onDelete: _.bind(function () {
                            this.renderPageHelper();
                        }, this)
                    });
                }
            }, this);
            if (!model.isFetched) {
                model.fetch({
                    success: _.bind(function () {
                        fnEdit(model, company);
                    }, this)
                })
            } else {
                fnEdit(model, company);
            }
        }, this)

        if (!(model.get('contactCompanyId') > 0) || model.get('contactCompanyId') === model.id) {
            let company = new PJQ.models.contacts.Company({
                id: model.id
            });
            company.fetch({
                success: _.bind(function () {
                    fnFetch(_.find(company.contacts.models, function (model) {
                        return model.get('isPrimary')
                    }), company);
                }, this)
            })
        } else if (!(model instanceof PJQ.models.contacts.Contact)) {
            fnFetch(new PJQ.models.contacts.Contact(model));
        } else {
            fnFetch(model);
        }
    },
    statusChanged: function (statuses) {
    },
    getCustomFieldColumn: function (customField, isCompany) {
        return {
            "columnData": (isCompany ? 'companyCustomField' : 'contactCustomField') + '_' + customField.get('id'),
            "title": customField.get('fieldName'),
            "data": (isCompany ? 'CompanyFieldValue' : 'FieldValue') + customField.get('fieldNumber'),
            "render": function (data, type, row) {
                let rowField;
                if (isCompany) {
                    rowField = _.find(row.get('companyCustomFieldValues'), function (cf) {
                        return (cf.id === customField.get('id'));
                    });
                } else {
                    rowField = _.find(row.get('contactCustomFieldValues'), function (cf) {
                        return (cf.id === customField.get('id'));
                    });
                }

                let fieldValue = null;
                if (rowField != null) {
                    fieldValue = rowField.value;
                }
                // if(fieldValue == null && customField.get('defaultValue') !== "") {
                // 	fieldValue = customField.get('defaultValue');
                // 	if(!isNaN(parseInt(fieldValue))){
                // 		fieldValue = parseInt(fieldValue);
                // 	}
                // }
                switch (customField.get('fieldType')) {
                    case PJQ.constants.customFields.fieldTypes.TEXT:
                        if (fieldValue && type !== 'sort' && type !== 'type') {
                            if (PJQ.helpers.urlHelpers.isURL(fieldValue))
                                fieldValue = '<a target="_blank" href="' + fieldValue + '">' + fieldValue + '</a>';
                        }
                        break
                    case PJQ.constants.customFields.fieldTypes.DATE:
                        if (fieldValue) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                        if (_.size(fieldValue) > 0) {
                            if (type !== 'sort' && type !== 'type')
                                fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.BOOL:
                        if (fieldValue != null)
                            fieldValue = fieldValue ? 'Yes' : 'No';
                        else
                            fieldValue = '';
                        break;
                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                        if (fieldValue) {
                            let choices = [];

                            // convert single choice value into array so that the logic below can work for both types.
                            if (typeof fieldValue === 'number')
                                fieldValue = [fieldValue];

                            _.each(customField.choices.models, _.bind(function (choice) {
                                if (_.find(fieldValue, function (value) {
                                    return value === choice.get('id');
                                }))
                                    choices.push(choice.get('choiceName'));
                            }, this));

                            fieldValue = choices.join((', '));

                            if (customField.get('fieldName').toLowerCase() === "approval level") {
                                let textColor;
                                if (fieldValue.toLowerCase() === 'green' || fieldValue.toLowerCase() === 'approved') {
                                    textColor = '#28a745'
                                }
                                if (fieldValue.toLowerCase() === 'yellow' || fieldValue.toLowerCase() === 'approved limited') {
                                    textColor = '#ffc107'
                                }
                                if (fieldValue.toLowerCase() === 'red' || fieldValue.toLowerCase() === 'not approved') {
                                    textColor = '#dc3545'
                                }
                                fieldValue = '<span style="color: ' + textColor + ';">' + fieldValue + '</span>';
                            }
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.PERCENT:
                        if (type !== 'sort' && type !== 'type') {
                            fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.MONEY:
                        if (type === 'sort' || type === 'type') {
                            if (fieldValue && fieldValue !== '$')
                                fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                            else
                                fieldValue = 0;

                        } else {
                            fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(fieldValue, 2) : '';
                        }
                        break;
                    case PJQ.constants.customFields.fieldTypes.PHONE:
                        if (type !== 'sort' && type !== 'type') {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue) : 'N/A'),
                                phoneWrapped = (fieldValue ? PJQ.helpers.formatHelpers.formatPhoneNumber(fieldValue, true) : 'N/A');

                            if (fieldValue !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (fieldValue ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';

                            fieldValue = html;
                        }
                        break;
                }
                return fieldValue;
            },
            "customFieldId": customField.get('id')
        };
    },
    childRowToggle: function (sender) {
        let $target = $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let childData = this.getRowChildData(row);
            if (childData != null) {
                let loader = new PJQ.Loader(this.$el.parent());
                childData.fetch({
                    type: 'POST',
                    data: {
                        searchFor: this.options.addressBookView.filter.searchFor,
                        locationFilter: this.options.addressBookView.filter.locationFilter,
                        zip: this.options.addressBookView.filter.zip,
                        radius: this.options.addressBookView.filter.radius,
                        directoryFilter: this.options.addressBookView.filter.directoryFilter,
                        userTypeFilter: this.options.addressBookView.filter.userTypeFilter,
                        groups: (childData.options.groupId != undefined && childData.options.groupId != null)  ? [childData.options.groupId] : this.options.addressBookView.filter.groups,
                        groupDescription: childData.options.groupDescription,
                        page: 1,
                        pageSize: 2147483646,
                        isAdvancedSearch: this.options.addressBookView.isAdvancedSearch,
                        advancedSearch: this.options.addressBookView.advancedSearch,
                        contactCompanyId: childData.options.contactCompanyId,
                        contactId: childData.options.contactId,
                        isFilterApproved: this.options.addressBookView.filter.isFilterApproved,
                        isPrimaryOnly: this.options.addressBookView.filter.isPrimaryOnly,
                        isFilterUnapproved: this.options.addressBookView.filter.isFilterUnapproved,
                        proqualFilter: this.options.addressBookView.filter.proqualFilter,
                        isFilterActive: this.options.addressBookView.filter.isFilterActive,
                        isFilterInactive: this.options.addressBookView.filter.isFilterInactive,
                        isFilterUnion: this.options.addressBookView.filter.isFilterUnion,
                        isFilterNonUnion: this.options.addressBookView.filter.isFilterNonUnion,
                        isFilterPrevWage: this.options.addressBookView.filter.isFilterPrevWage,
                        isFilterNoLaborStatus: this.options.addressBookView.filter.isFilterNoLaborStatus,
                        isIncludeGroupList: this.options.addressBookView.settings.hasGroupListColumn(this.getChildTableType()),
                        includeScreeningPackages: this.options.addressBookView.settings.hasScreeningPackagesColumn(this.getChildTableType()),
                        includeContactCustomFields: this.options.addressBookView.settings.getContactCustomFieldColumns(this.getChildTableType()),
                        includeCompanyCustomFields: this.options.addressBookView.settings.getCompanyCustomFieldColumns(this.getChildTableType()),
                        isSelectionMode: !(this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
                    },
                    success: _.bind(function () {
                        loader.remove();
                        let childTable = this.getRowChildTable({
                            el: $childTable,
                            data: childData.models,
                            collection: childData,
                            requestData: {
                                searchFor: this.options.addressBookView.filter.searchFor,
                                locationFilter: this.options.addressBookView.filter.locationFilter,
                                zip: this.options.addressBookView.filter.zip,
                                radius: this.options.addressBookView.filter.radius,
                                directoryFilter: this.options.addressBookView.filter.directoryFilter,
                                userTypeFilter: this.options.addressBookView.filter.userTypeFilter,
                                groups: childData.options.groupId !== null ? [childData.options.groupId] : this.options.addressBookView.filter.groups,
                                groupDescription: childData.options.groupDescription,
                                page: 1,
                                pageSize: 2147483646,
                                isAdvancedSearch: this.options.addressBookView.isAdvancedSearch,
                                advancedSearch: this.options.addressBookView.advancedSearch,
                                contactCompanyId: childData.options.contactCompanyId,
                                contactId: childData.options.contactId,
                                isFilterApproved: this.options.addressBookView.filter.isFilterApproved,
                                isPrimaryOnly: this.options.addressBookView.filter.isPrimaryOnly,
                                isFilterUnapproved: this.options.addressBookView.filter.isFilterUnapproved,
                                proqualFilter: this.options.addressBookView.filter.proqualFilter,
                                isFilterActive: this.options.addressBookView.filter.isFilterActive,
                                isFilterInactive: this.options.addressBookView.filter.isFilterInactive,
                                isFilterUnion: this.options.addressBookView.filter.isFilterUnion,
                                isFilterNonUnion: this.options.addressBookView.filter.isFilterNonUnion,
                                isFilterPrevWage: this.options.addressBookView.filter.isFilterPrevWage,
                                isFilterNoLaborStatus: this.options.addressBookView.filter.isFilterNoLaborStatus,
                                isIncludeGroupList: this.options.addressBookView.settings.hasGroupListColumn(this.getChildTableType()),
                                includeScreeningPackages: this.options.addressBookView.settings.hasScreeningPackagesColumn(this.getChildTableType()),
                                includeContactCustomFields: this.options.addressBookView.settings.getContactCustomFieldColumns(this.getChildTableType()),
                                includeCompanyCustomFields: this.options.addressBookView.settings.getCompanyCustomFieldColumns(this.getChildTableType()),
                                isSelectionMode: !(this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.NONE)
                            },
                            parentId: id,
                            addressBookView: this.options.addressBookView
                        });
                        this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                            return childDt.options.parentId !== id;
                        }, this));
                        this.options.childDataTables.push(childTable);
                        tr.addClass('shown');
                    }, this)
                });
            }
        }
    },
    /*
    childRowToggleAll: function (sender) {
        let $target = $(sender.currentTarget);

        this.dataTable.rows().eq(0).each(_.bind(function (index) {
            let row = this.dataTable.row(index), id = row.data().get('groupId');

            if ($target.hasClass('fa-plus-circle') && !row.child.isShown()) {
                let childClass = 'subgrid-' + id.toString(),
                    $childTable = $('<div data-id="' + id + '" />', {
                        class: childClass
                    });
                row.child($childTable).show();

                let childData = this.getRowChildData(row);
                if (childData != null) {
                    childData.fetch({
                        success: _.bind(function () {
                            let childTable = this.getRowChildTable({
                                el: $childTable,
                                data: childData.models,
                                parentDataTable: this,
                                parentId: id,
                                addressBookView: this.options.addressBookView
                            });
                            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                                return childDt.options.parentId !== id;
                            }, this));
                            this.options.childDataTables.push(childTable);
                            $(row.node()).addClass('shown');
                        }, this)
                    });
                }
            }
            else if ($target.hasClass('fa-minus-circle') && row.child.isShown()) {
                row.child.hide();
                $(row.node()).removeClass('shown');
            }

        }, this));

        if ($target.hasClass('fa-plus-circle'))
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        else
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
    },
     */
    getColumns: function () {
    },
    cleanup: function () {
        this.undelegateEvents();
        $(this.el).empty();
    },
    getIsRootView: function () {
        return (this.options.view.indexOf('-') === -1);
    },
    createdRow: function (row, data, dataIndex) {
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone').replace(/ /g,''),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    }
});

PJQ.views.addressbook.ContactDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.contact-toggle-row': 'childRowToggle',
        'click .select-contact': 'contactSelectChanged',
        'click .select-all-contacts': 'contactSelectAllChanged',
        "click .btn-show-groups": "showRowGroups",
        'click .btn-copy-phone': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-fax': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-cell': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyPhone(e)
            }
        },
        'click .btn-copy-email': function (e) {
            if (this.options.view === PJQ.constants.addressBook.view.CONTACT || this.options.view.includes('groupcontact')) {
                this.copyEmail(e)
            }
        },
    },
    getContextMenuItems: function (a) {
        return [
            {
                name: PJQ.app.session.hasPermission('contacts.canEditContact') ? 'Edit Contact' : 'View Contact',
                iconClass: 'fal fa-user',
                onClick: _.bind(function (row) {
                    this.editContact(row.data());
                }, this)
            },
            {
                name: 'Export Excel',
                iconClass: 'fal fa-file-excel',
                onClick: _.bind(function (row) {
                    row.data().exportExcel();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Approve Contact',
                iconClass: 'fal fa-thumbs-up',
                onClick: _.bind(function (row) {
                    let apprModel = row.data();
                    apprModel.approve(_.bind(function () {
                        if (typeof this.options.onApprove === 'function') {
                            this.options.onApprove(apprModel);
                        }
                        this.render();
                    }, this));
                }, this),
                isShown: _.bind(function (row) {
                    return row.data().get('isApprovalRequired') && PJQ.app.session.hasPermission('contacts.canApprove');
                }, this)
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId')
                    })
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Copy',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'copydirectorycontact'
                            },
                        ])
                    }).post().done(_.bind(function (data) {
                        this.render();
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: err.indexOf('Logic') === -1 ? err : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    row.data().getVcard();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Send Updater',
                iconClass: 'fal fa-poll-h',
                onClick: _.bind(function (row) {

                    let callback = function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contact Updater Request sent'
                        });
                    };

                    new PJQ.views.modals.YesNo({
                        header: "Send Contact Updater",
                        body: "Are you sure you want to send this contact an Update Request?",
                        onYes: _.bind(function () {
                            row.data().sendUpdater(callback);
                        }, this)
                    });

                }, this)
            },
            {
                name: 'Request Prequal',
                iconClass: 'fal fa-file-invoice',
                onClick: _.bind(function (row) {

                    new PJQ.views.modals.YesNo({
                        header: "Send Prequalification Request",
                        body: "Are you sure you want to send this contact an Prequalification Request?",
                        onYes: _.bind(function () {
                            new PJQ.ajax.Request({
                                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                    {
                                        endpoint: 'contacts',
                                        value: row.data().get('contactId')
                                    },
                                    {
                                        endpoint: 'prequal'
                                    },
                                    {
                                        endpoint: 'request'
                                    }
                                ])
                            }).post().done(_.bind(function (data) {
                                if (data && data.success) {
                                    PJQ.notifications.notify.successNotify({
                                        message: 'Qualification update sent'
                                    });
                                    $('.prequal-request-update').html('<i class="fal fa-check mr-1"></i>Update Sent').prop('disabled', true);
                                } else {
                                    PJQ.notifications.notify.errorNotify({
                                        message: 'Qualification update failed, invalid email address on contact'
                                    });
                                }
                            }, this)).fail(function (xhr, err, result) {
                                new PJQ.logging.Debug(PJQ.logging.LoggingActions.SEND_PREQUAL_UPDATE, {
                                    error: err,
                                    result: result
                                });
                            });

                        }, this)
                    });

                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('prequal.canView') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PREQUAL)
                }, this)
            },
            {
                name: 'Delete Contact',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Contact",
                        body: "Are you sure you want to delete this contact from the address book?",
                        onDelete: _.bind(function () {
                            row.data().destroy({
                                success: _.bind(function() {
                                    // hide children
                                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                                        if (row.child.isShown())
                                            row.child.hide();
                                    }
                                    let parentTR = this.options.parentDataTable ? $(row.node()).parent().closest('tr').prev() : null,
                                        parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

                                    row.remove().draw(false);

                                    if (this.options.parentDataTable && this.options.addressBookView.currentView !== PJQ.constants.addressBook.view.TRADES_CONTACT) {
                                        if (parentRow.data().get('contactCount') === 1)
                                            parentRow.remove().draw(false);
                                    }
                                }, this)
                            });

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
                }, this)
            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    row.data().showProjectHistory();
                }, this),
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'contactName', 'title', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone', 'cell', 'fax', 'email', 'contactId', 'contactCompanyId', 'isAutoSelectDisabled', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'gradeAverage', 'userType', 'activityRank', 'prequalPercent', 'prequalExpiresOn'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
            includeColumns.push('screeningPackages');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (this.options.isShowCheckboxes) {
            columns.push({
                "columnData": '',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(this.renderContactSelect, this)
            });
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.addressBookView && this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                columns.push({
                    "columnData": "contactGroups",
                    "data": null,
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle contact-toggle-row" data-type="contactId" data-id="' + row.get('contactId') + '"></i>';
                    }
                });
            }
        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];
                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<i class='fas fa-user-clock fs-18 mr-1' title='Qualification Pending'></i>");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-edit fs-18 mr-1' title='Qualification In Process'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-search fs-18 mr-1' title='Qualification Needs Review'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-check fs-18 mr-1' title='All Enrolled'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-clipboard-list-check fs-18 mr-1' title='Qualification Feedback Required'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<i class='fas fa-file-exclamation fs-18 mr-1' title='Qualification Expired'></i>");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('masterUserId') === 39)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18 mr-1' title='Prequalification Available'></i>");
                            }

                            if (row.get('isApprovalRequired')) {
                                icons.push("<i class='fas fa-exclamation-circle text-gold fs-18 mr-1' title='Awaiting Approval'></i>");
                            }

                            if (row.get('updatedOn') != null) {
                                icons.push("<i class='fas fa-check-circle text-success fs-18 mr-1' title='Updated by Contact at " + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('updatedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "'></i>");
                            }

                            if (row.get('isPrimary')) {
                                icons.push("<i class='fal fa-crown fs-18' title='Primary Contact'></i>");
                            }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'contactName':
                    columns.push({
                        "columnData": "contactName",
                        "data": "attributes.contactName",
                        "title": "Contact",
                    });
                    break;
                case 'contactCompanyId':
                    columns.push({
                        "columnData": "contactCompanyId",
                        "data": "attributes.contactCompanyId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) : "Company ID",
                    });
                    break;
                case 'contactId':
                    columns.push({
                        "columnData": "contactId",
                        "data": "attributes.contactId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_ID_LABEL) : "Contact ID",
                    });
                    break;
                case 'isAutoSelectDisabled':
                    columns.push({
                        "columnData": "isAutoSelectDisabled",
                        "data": "attributes.isAutoSelectDisabled",
                        "title": "Selection Status",
                        "render": _.bind(function (data, type, row) {
                            return data ? 'Off' : 'On'
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "columnData": "address1",
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "columnData": "address2",
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "columnData": "city",
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "columnData": "state",
                        "data": "attributes.state",
                        "title": "State",
                    });
                    break;
                case 'zip':
                    columns.push({
                        "columnData": "zip",
                        "data": "attributes.zip",
                        "title": "Zip",
                    });
                    break;
                case 'country':
                    columns.push({
                        "columnData": "country",
                        "data": "attributes.country",
                        "title": "Country",
                    });
                    break;
                case 'phone':
                    columns.push({
                        "columnData": "phone",
                        "data": "attributes.phone",
                        "title": "Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A'),
                                phoneWrapped = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone'), true) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'cell':
                    columns.push({
                        "columnData": "cell",
                        "data": "attributes.cell",
                        "title": "Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A'),
                                phoneWrapped = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell'), true) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'fax':
                    columns.push({
                        "columnData": "fax",
                        "data": "attributes.fax",
                        "title": "Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A'),
                                phoneWrapped = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax'), true) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'email':
                    columns.push({
                        "columnData": "email",
                        "data": "attributes.email",
                        "title": "Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "title": 'Union Status',
                        "data": 'unionStatus',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "title": 'Labor Sector',
                        "data": 'sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "data": 'certifications',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupArray = data.split(',')
                            if (_.size(groupArray) > 5) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - 5).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - 5) + " more item(s)</a>"
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'gradeAverage':
                    columns.push({
                        "columnData": 'gradeAverage',
                        "title": 'Grade',
                        "data": 'grade',
                        "render": function (data, type, row) {
                            return row.get('gradeAverage').toFixed(1);
                        }
                    });
                    break;
                case 'userType':
                    columns.push({
                        "columnData": 'userType',
                        "title": 'Contact Type',
                        "data": 'userType',
                        "render": function (data, type, row) {
                            let userType = _.filter(PJQ.app.session.userTypes.getByIsCompany(false), _.bind(function (userType) {
                                return row.get('userTypeId') === userType.get('userTypeId');
                            }, this))[0];

                            return userType != null ? userType.get('name') : 'N/A';
                        }
                    });
                    break;
                case 'activityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'activityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Activity'
                        });
                    }
                    break;
                case 'prequalPercent':
                    columns.push({
                        "columnData": "prequalPercent",
                        "data": "attributes.prequalPercent",
                        "title": "Prequal Percent",
                        "render": function (data, type, row) {
                            if (data < 60) {
                                return '<span class="text-danger">' + data + '</span>'
                            } else if (data === 100) {
                                return '<span class="text-success">' + data + '</span>'
                            } else if (data >= 60) {
                                return '<span class="text-warning">' + data + '</span>'
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'prequalExpiresOn':
                    columns.push({
                        "columnData": "prequalExpiresOn",
                        "data": "attributes.prequalExpiresOn",
                        "title": "Prequal Expires",
                        "render": function (data, type, row) {
                            let expiresOn = data;
                            if (expiresOn != null) {
                                let expiresOnDate = new Date(expiresOn);
                                return '<span style="color: '+(PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expiresOnDate) ? PJQ.constants.colors.RED : PJQ.constants.colors.GREEN)+'">' + PJQ.helpers.dateHelpers.getDateString(expiresOnDate, PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                            } else {
                                return 'N/A';
                            }
                        }
                    });
                    break;
                case 'screeningPackages':
                    columns.push({
                        "columnData": "screeningPackages",
                        "data": "attributes.screeningPackages",
                        "title": "Qualification Packages",
                        "render": _.bind(function (data, type, row) {
                            let ct = _.size(data);
                            if (ct > 0) {
                                let packageNames = [];
                                _.each(this.options.addressBookView.screeningSettings.get('packages'), function (pkg) {
                                    if (data.indexOf(pkg.screeningPackageId) !== -1) {
                                        packageNames.push(pkg.packageName);
                                    }
                                });
                                return '<div>' + packageNames.join(', ') + '</div>'
                            }
                            return 'None';
                        }, this)
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    getChildTableType: function () {
        return PJQ.constants.addressBook.view.CONTACT_GROUP;
    },
    getChildTableSettings: function () {
        return null; //this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.order = [];
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = true;
        childOpts.paging = false;
        childOpts.beforeDataTableRender = this.options.beforeDataTableRender;

        return new PJQ.views.addressbook.ContactGroupDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: PJQ.constants.addressBook.view.CONTACT_GROUP,
            contactId: row.data().get('contactId'),
            groupId: row.data().collection.options.groupId
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-contact.indeterminate').prop('indeterminate', true);
    },
    isContactSelected: function (row) {
        let selected = (this.options.addressBookView.options.disabledContacts.indexOf(row.contactId) !== -1);

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            if (_.size(row.contactGroups) > 0) {
                selected = selected || _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)) > 0 ||
                    _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups)) > 0;
            } else {
                selected = selected || (this.options.addressBookView.selectedContactsNoGroup.indexOf(row.contactId) !== -1);
            }
        } else
            selected = selected || (this.options.addressBookView.selectedContactsAll.indexOf(row.contactId) !== -1);

        return selected;
    },
    isContactIndeterminate: function (row) {
        let indeterminate = false,
            contactGroups = _.size(row.contactGroups),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            if (contactGroups > 0 && (disabledGroups + selectedGroups > 0)) {
                indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups);
            }
        }

        return indeterminate;
    },
    isContactDisabled: function (row) {
        let disabled = (row.isBlacklisted === true && this.options.addressBookView.options.selectionMode !== PJQ.constants.addressBook.selectionMode.MERGE) || (this.options.addressBookView.options.disabledContacts.indexOf(row.contactId) !== -1);
        if (_.size(row.contactGroups) > 0) {
            disabled = disabled || _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)) === _.size(row.contactGroups);
        }

        return disabled;
    },
    renderContactSelect: function (data, type, row) {
        let isSelected = this.isContactSelected(row.attributes),
            isIndeterminate = this.isContactIndeterminate(row.attributes),
            isDisabled = this.isContactDisabled(row.attributes);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth' + (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT ? ' p-has-indeterminate' : '') + ' fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected && !isIndeterminate ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-contact' + (isIndeterminate ? ' indeterminate ' : '') + '" />';

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            html += '<div class="state"><i class="icon far fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
                '<div class="state p-is-indeterminate"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>';
        } else {
            html += '<div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>';
        }

        html += '</div></div>';

        return (html);
    },
    updateContactSelect: function (row) {
        let isSelected = this.isContactSelected(row.data().attributes),
            isIndeterminate = this.isContactIndeterminate(row.data().attributes),
            isDisabled = this.isContactDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');

        if (isIndeterminate)
            $cb.prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        else if (isSelected)
            $cb.prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        else
            $cb.prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
    },
    contactSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null;

        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsAll([row.data().get('contactId')]);

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                if (_.size(row.data().get('contactGroups')) > 0)
                    this.options.addressBookView.addSelectedContactGroups(row.data().get('contactGroups'));
                else
                    this.options.addressBookView.addSelectedContactsNoGroup([row.data().get('contactId')]);
            }
        } else {
            this.options.addressBookView.removeSelectedContactsAll([row.data().get('contactId')]);

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                if (_.size(row.data().get('contactGroups')) > 0)
                    this.options.addressBookView.removeSelectedContactGroups(row.data().get('contactGroups'));
                else
                    this.options.addressBookView.removeSelectedContactsNoGroup([row.data().get('contactId')]);
            }
        }

        this.updateContactSelect(row);

        // cascade up to parents
        if (this.options.parentDataTable && parentRow) {
            if ([PJQ.constants.addressBook.view.COMPANY, PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY].indexOf(this.options.parentDataTable.options.view) !== -1) {
                this.options.parentDataTable.updateCompanySelect(parentRow);
            }
        }

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
            [PJQ.constants.addressBook.view.CONTACT, PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.view) !== -1) {
            _.each(this.options.childDataTables, _.bind(function (childDT) {
                if (childDT.options.parentId === row.data().get('contactId')) {
                    _.each(childDT.$el.find('.select-contactgroup'), _.bind(function (input) {
                        childDT.updateContactGroupSelect(childDT.getRow($(input).closest('tr')));
                    }, this));
                }
            }, this));
        }

    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(',')
        target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
    },
    contactSelectAllChanged: function (e) {
        let parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            callback = _.bind(function () {
                _.each(this.$el.find('.select-contact'), _.bind(function (input) {
                    this.updateContactSelect(this.getRow($(input).closest('tr')));
                }, this));

                if (this.options.parentDataTable && [PJQ.constants.addressBook.view.COMPANY, PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY].indexOf(this.options.parentDataTable.options.view) !== -1) {
                    this.options.parentDataTable.updateCompanySelect(parentRow);
                }

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                    [PJQ.constants.addressBook.view.CONTACT, PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.view) !== -1) {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        _.each(childDT.$el.find('.select-contactgroup'), _.bind(function (input) {
                            childDT.updateContactGroupSelect(childDT.getRow($(input).closest('tr')));
                        }, this));
                    }, this));
                }
            }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // loop through our data, add everyone, and update the checkboxes.
            let contacts = [],
                contactGroups = [],
                contactsNoGroup = [];

            _.each(this.$el.find('.select-contact'), _.bind(function (input) {
                let row = this.getRow($(input).closest('tr'));
                if (!row.data().get('isAutoSelectDisabled') && !row.data().get('isBlacklisted') && !row.data().get('isCompanyBlacklisted')) {
                    contacts.push(row.data().get('contactId'));
                    $.merge(contactGroups, row.data().get('contactGroups'));
                    if (_.size(row.data().get('contactGroups')) === 0)
                        contactsNoGroup.push(row.data().get('contactId'));
                }
            }, this));

            if ($(e.currentTarget).prop('checked')) {
                this.options.addressBookView.addSelectedContactsAll(contacts);

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.addSelectedContactGroups(contactGroups);
                    this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup)
                }
            } else {
                this.options.addressBookView.removeSelectedContactsAll(contacts);

                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.removeSelectedContactGroups(contactGroups);
                    this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup)
                }
            }

            callback();
        }

    }
});

PJQ.views.addressbook.CompanyDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.company-toggle-row': 'childRowToggle',
        'click .select-company': 'companySelectChanged',
        'click .select-all-companies': 'companySelectAllChanged',
        'click .btn-copy-phone': 'copyPhone',
        'click .btn-copy-fax': 'copyPhone',
        'click .btn-copy-cell': 'copyPhone',
        'click .btn-copy-email': 'copyEmail',
        "click .btn-show-groups": "showRowGroups"
    },
    getContextMenuItems: function () {
        return [
            {
                name: PJQ.app.session.hasPermission('contacts.canEditContact') ? 'Edit Contact' : 'View Contact',
                iconClass: 'fal fa-user',
                onClick: _.bind(function (row) {
                    this.editContact(row.data());
                }, this)
            },
            {
                name: 'Export Excel',
                iconClass: 'fal fa-file-excel',
                onClick: _.bind(function (row) {
                    row.data().exportExcel();
                }, this),
                isShown: _.bind(function (row) {
                    return PJQ.app.session.hasPermission('contacts.canExport');
                }, this)
            },
            {
                name: 'Export vCard',
                iconClass: 'fal fa-address-card',
                onClick: _.bind(function (row) {
                    let contact = new PJQ.models.contacts.Contact(row.data());
                    contact.getVcard();
                }, this),
            },
            {
                name: 'Report',
                iconClass: 'fal fa-flag',
                onClick: _.bind(function (row) {
                    new PJQ.views.contacts.ReportContactModal({
                        contactId: row.data().get('contactId')
                    })
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Copy',
                iconClass: 'fal fa-copy',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: row.data().get('contactId')
                            },
                            {
                                endpoint: 'copydirectorycontact'
                            },
                        ])
                    }).post().done(_.bind(function (data) {
                        this.render();
                    }, this)).fail(function (xhr, err, result) {
                        PJQ.notifications.notify.errorNotify({
                            message: err.indexOf('Logic') === -1 ? err : 'Something went wrong!'
                        });
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return isDirectoryContact;
                }, this)
            },
            {
                name: 'Delete Company',
                iconClass: 'fal fa-trash',
                isDanger: true,
                onClick: _.bind(function (row) {
                    new PJQ.views.modals.DeleteCancel({
                        header: "Delete Company",
                        body: "Are you sure you want to delete this company from the address book?  NOTE: All contacts in this company will also be deleted, including ones that may not be visible due to filters.",
                        onDelete: _.bind(function () {
                            let contact = new PJQ.models.contacts.Company(row.data().attributes);
                            contact.destroy();

                            if (row.child.isShown())
                                row.child.hide();

                            row.remove().draw(false);
                            this.dataTable.rows().invalidate().draw(false);

                        }, this)
                    });
                }, this),
                isShown: _.bind(function (row) {
                    let isDirectoryContact = row.data().get('masterUserId') === 39
                    return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
                }, this)
            },
            {
                name: 'Project History',
                iconClass: 'fal fa-history',
                onClick: _.bind(function (row) {
                    let contact = new PJQ.models.contacts.Contact(row.data().attributes);
                    contact.showProjectHistory();
                }, this),
            }
        ]
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['icons', 'companyName', 'primaryContactName', 'primaryContactTitle', 'primaryContactUserType', 'primaryAddress1', 'primaryAddress2', 'primaryCity', 'primaryState', 'primaryZip', 'primaryCountry', 'primaryPhone', 'primaryCell', 'primaryFax', 'primaryEmail', 'contactCompanyId', 'unionStatus', 'sector', 'certifications', 'groupListDisplay', 'gradeAverage', 'primaryActivityRank', 'companyActivityRank', 'contactCount', 'prequalPercent', 'prequalExpiresOn'];

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS)) {
            includeColumns.push('screeningPackages');
        }

        _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('companyCustomField_' + customField.id);
        }, this));

        _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
            includeColumns.push('contactCustomField_' + customField.id);
        }, this));

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            if (this.options.isShowCheckboxes) {
                columns.push({
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-companies" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderCompanySelect, this)
                });
            }

            columns.push({
                "columnData": "companyContacts",
                "data": null,
                "title": "",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    return '<i class="fal fa-plus-circle company-toggle-row" data-type="contactCompanyId" data-id="' + row.get('contactCompanyId') + '"></i>';
                }
            });

        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'icons':
                    columns.push({
                        "columnData": "icons",
                        "data": null,
                        "title": 'Info',
                        "width": '50px',
                        "orderable": false,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];
                            // proqual stuff
                            if (row.get('hasUnpaidInvites'))
                                icons.push("<i class='fas fa-user-clock fs-18 mr-1' title='Qualification Pending'></i>");
                            else if (row.get('minScreeningStatusId') < PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-edit fs-18 mr-1' title='Qualification In Process'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') === 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-search fs-18 mr-1' title='Qualification Needs Review'></i>");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.Complete &&
                                row.get('maxScreeningInviteId') > 0 && row.get('minScreeningGradeId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/screening_allclear.png' title='Qualification Approved' />");
                            else if (row.get('minScreeningStatusId') >= PJQ.constants.proQual.screeningStatuses.InProcess &&
                                row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-file-check fs-18 mr-1' title='All Enrolled'></i>");
                            if (row.get('maxScreeningInviteId') > 0 && row.get('screeningCountFeedbackItems') > 0 && new Date(row.get('maxInviteExpiresOn')) > new Date())
                                icons.push("<i class='fas fa-clipboard-list-check fs-18 mr-1' title='Qualification Feedback Required'></i>");

                            if (row.get('maxScreeningInviteId') > 0 && new Date(row.get('maxInviteExpiresOn')) < new Date())
                                icons.push("<i class='fas fa-file-exclamation fs-18 mr-1' title='Qualification Expired'></i>");

                            // directory stuff
                            if (row.get('networkVerificationLevel') === 1)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/select_network_icon.png' title='Select Network Member' />");
                            else if (row.get('networkVerificationLevel') === 2)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/verified_network_icon.png' title='Verified Network Member' />");
                            else if (row.get('masterUserId') === 39)
                                icons.push("<img class='project-participant-icon mr-1' src='/assets/modules2/global/images/directory_sub.png' title='Pantera Directory Member' />");

                            if (row.get('hasPrequal')) {
                                icons.push("<i class='fas fa-check text-gold fs-18' title='Prequalification Available'></i>");
                            }


                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    });
                    break;
                case 'companyName':
                    columns.push({
                        "columnData": "companyName",
                        "data": "attributes.companyName",
                        "title": "Company",
                    });
                    break;
                case 'primaryContactName':
                    columns.push({
                        "columnData": "primaryContactName",
                        "data": "attributes.contactName",
                        "title": "Primary Contact",
                    });
                    break;
                case 'primaryTitle':
                    columns.push({
                        "columnData": "primaryTitle",
                        "data": "attributes.title",
                        "title": "Primary Title"
                    });
                    break;
                case 'primaryContactUserType':
                    columns.push({
                        "columnData": "primaryContactUserType",
                        "data": "attributes.defaultContactUserTypeId",
                        "title": "Primary User Type",
                        "render": _.bind(function (data, type, row) {
                            let userType = PJQ.app.session.userTypes.get(data);
                            if(userType){
                                return '<span style="color: ' + userType.get('color') +' !important;">' + userType.get('name') + '</span>';
                            }
                        }, this)
                    });
                    break;
                case 'primaryAddress1':
                    columns.push({
                        "columnData": "primaryAddress1",
                        "data": "attributes.address1",
                        "title": "Primary Address 1"
                    });
                    break;
                case 'primaryAddress2':
                    columns.push({
                        "columnData": "primaryAddress2",
                        "data": "attributes.address2",
                        "title": "Primary Address 2"
                    });
                    break;
                case 'primaryCity':
                    columns.push({
                        "columnData": "primaryCity",
                        "data": "attributes.city",
                        "title": "Primary City"
                    });
                    break;
                case 'primaryState':
                    columns.push({
                        "columnData": "primaryState",
                        "data": "attributes.state",
                        "title": "Primary State",
                        "width": "100px",
                    });
                    break;
                case 'primaryZip':
                    columns.push({
                        "columnData": "primaryZip",
                        "data": "attributes.zip",
                        "title": "Primary Zip",
                    });
                    break;
                case 'primaryCountry':
                    columns.push({
                        "columnData": "primaryCountry",
                        "data": "attributes.country",
                        "title": "Primary Country",
                    });
                    break;
                case 'primaryPhone':
                    columns.push({
                        "columnData": "primaryPhone",
                        "data": "attributes.phone",
                        "title": "Primary Phone",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A'),
                                phoneWrapped = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone'), true) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

                            if (row.get('phone') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryCell':
                    columns.push({
                        "columnData": "primaryCell",
                        "data": "attributes.cell",
                        "title": "Primary Cell",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell')) : 'N/A'),
                                phoneWrapped = (row.get('cell') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('cell'), true) : 'N/A');

                            if (row.get('cell') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Cell #" data-phone="' + phoneFormatted + '"><i class="far fa-mobile-alt text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('cell') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryFax':
                    columns.push({
                        "columnData": "primaryFax",
                        "data": "attributes.fax",
                        "title": "Primary Fax",
                        "width": this.options.phoneWidth,
                        "render": _.bind(function (data, type, row) {
                            let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
                                phoneFormatted = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax')) : 'N/A'),
                                phoneWrapped = (row.get('fax') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('fax'), true) : 'N/A');

                            if (row.get('fax') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Fax #" data-phone="' + phoneFormatted + '"><i class="far fa-fax text-dark"></i></button>';

                            html += '<div class="flex-fill ' + (row.get('fax') ? '' : 'text-muted') + '">' + phoneWrapped + '</div>';
                            html += '</div>';
                            return html;
                        }, this)
                    });
                    break;
                case 'primaryEmail':
                    columns.push({
                        "columnData": "primaryEmail",
                        "data": "attributes.email",
                        "title": "Primary Email",
                        "render": function (data, type, row) {
                            let html = '<div style="max-width:' + (maxEmailWidth != null ? (maxEmailWidth.toString() + 'px;') : 'auto') + '" class="d-flex align-items-center wd-100">',
                                emailFormatted = (row.get('email') ? ('<a title="' + row.get('email') + '" style="color: inherit;" href="mailto:' + row.get('email') + '">' + row.get('email') + '</a>') : '');

                            if (row.get('email') !== '')
                                html += '<button type="button" class="btn btn-transparent-dark btn-copy-email" title="Copy Email" data-email="' + row.get('email') + '"><i class="far fa-envelope text-dark"></i></button>';

                            html += '<div class="flex-fill of-hidden tof-ellipsis no-wrap' + (row.get('email') ? '' : 'text-muted') + '">' + emailFormatted + '</div></div>';
                            return html;
                        }
                    });
                    break;
                case 'contactCompanyId':
                    columns.push({
                        "columnData": "contactCompanyId",
                        "data": "attributes.contactCompanyId",
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL) : "Company ID",
                    });
                    break;
                case 'unionStatus':
                    columns.push({
                        "columnData": 'unionStatus',
                        "data": "unionStatus",
                        "title": 'Union Status',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isUnion'))
                                status.push('Union');
                            if (row.get('isNonUnion'))
                                status.push('Non-Union');
                            if (row.get('isPrevailingWage'))
                                status.push('Prevailing Wage');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'sector':
                    columns.push({
                        "columnData": 'sector',
                        "data": "sector",
                        "title": 'Labor Sector',
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isPublicSector'))
                                status.push('Public');
                            if (row.get('isPrivateSector'))
                                status.push('Private');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'certifications':
                    columns.push({
                        "columnData": 'certifications',
                        "title": 'Certification',
                        "data": "certifications",
                        "render": function (data, type, row) {
                            let status = [];
                            if (row.get('isDBE'))
                                status.push('DBE');
                            if (row.get('isDVBE'))
                                status.push('DVBE');
                            if (row.get('isMBE'))
                                status.push('MBE');
                            if (row.get('isSBE'))
                                status.push('SBE');
                            if (row.get('isSDVBE'))
                                status.push('SDVBE');
                            if (row.get('isWBE'))
                                status.push('WBE');

                            if (_.size(status) === 0)
                                status.push('N/A');

                            return status.join(',');
                        }
                    });
                    break;
                case 'groupListDisplay':
                    columns.push({
                        "columnData": "groupListDisplay",
                        "data": "attributes.groupListDisplay",
                        "title": "Trades",
                        "render": function (data) {
                            let groupArray = data.split(',')
                            if (_.size(groupArray) > 5) {
                                return _.rest(groupArray.reverse(), _.size(groupArray) - 5).reverse().join(', ') + " <br>" +
                                    "<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupArray) - 5) + " more item(s)</a>"
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'gradeAverage':
                    columns.push({
                        "columnData": 'gradeAverage',
                        "title": 'Grade',
                        "data": "grade",
                        "render": function (data, type, row) {
                            return row.get('gradeAverage').toFixed(1);
                        }
                    });
                    break;
                case 'primaryActivityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'primaryActivityRank',
                            "data": 'attributes.activityRank',
                            "title": 'Primary Activity'
                        });
                    }
                    break;
                case 'companyActivityRank':
                    if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_ACTIVITY_RANK_STATUS_LIST)) {
                        columns.push({
                            "columnData": 'companyActivityRank',
                            "data": 'attributes.companyActivityRank',
                            "title": 'Company Activity'
                        });
                    }
                    break;
                case 'contactCount':
                    columns.push({
                        "columnData": "contactCount",
                        "data": "attributes.contactCount",
                        "title": "Contacts",
                    });
                    break;
                case 'prequalPercent':
                    columns.push({
                        "columnData": "prequalPercent",
                        "data": "attributes.prequalPercent",
                        "title": "Prequal Percent",
                        "render": function (data, type, row) {
                            if (data < 60) {
                                return '<span class="text-danger">' + data + '</span>'
                            } else if (data === 100) {
                                return '<span class="text-success">' + data + '</span>'
                            } else if (data >= 60) {
                                return '<span class="text-warning">' + data + '</span>'
                            } else {
                                return data
                            }
                        }
                    });
                    break;
                case 'prequalExpiresOn':
                    columns.push({
                        "columnData": "prequalExpiresOn",
                        "data": "attributes.prequalExpiresOn",
                        "title": "Prequal Expires",
                        "render": function (data, type, row) {
                            let expiresOn = data;
                            if (expiresOn != null) {
                                let expiresOnDate = new Date(expiresOn);
                                return '<span style="color: '+(PJQ.helpers.dateHelpers.checkDateIsBeforeToday(expiresOnDate) ? PJQ.constants.colors.RED : PJQ.constants.colors.GREEN)+'">' + PJQ.helpers.dateHelpers.getDateString(expiresOnDate, PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                            } else {
                                return 'N/A';
                            }
                        }
                    });
                    break;
                case 'screeningPackages':
                    columns.push({
                        "columnData": "screeningPackages",
                        "data": "attributes.screeningPackages",
                        "title": "Qualification Packages",
                        "render": _.bind(function (data, type, row) {
                            let ct = _.size(data);
                            if (ct > 0) {
                                let packageNames = [];
                                _.each(this.options.addressBookView.screeningSettings.get('packages'), function (pkg) {
                                    if (data.indexOf(pkg.screeningPackageId) !== -1) {
                                        packageNames.push(pkg.packageName);
                                    }
                                });
                                return '<div>' + packageNames.join(', ') + '</div>'
                            }
                            return 'None';
                        }, this)
                    });
                    break;
            }

            if (columnName.startsWith('companyCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.company[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, true));
                }, this));
            }

            if (columnName.startsWith('contactCustomField_')) {
                let customFieldId = parseInt(columnName.substring(columnName.indexOf('_') + 1));

                _.each(PJQ.app.session.customFields.contact[PJQ.app.session.get('masterUserId')].models, _.bind(function (customField) {
                    if (customField.id === customFieldId)
                        columns.push(this.getCustomFieldColumn(customField, false));
                }, this));
            }

        }, this));

        return columns;
    },
    getChildTableType: function () {
        return this.options.view + '-contact';
    },
    getChildTableSettings: function () {
        return this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = this.options.addressBookView.isShowCheckboxes;
        childOpts.beforeDataTableRender = this.options.beforeDataTableRender;
        return new PJQ.views.addressbook.ContactDataTable(childOpts);
    },
    getRowChildData: function (row) {
        let viewOptions = {
            view: 'contact',
            contactCompanyId: row.data().get('contactCompanyId'),
            groupId: row.data().collection.options.groupId
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    afterDataTableRenderChild: function () {
        this.$el.find('.select-company.indeterminate').prop('indeterminate', 'true');
    },
    isCompanySelected: function (row) {
        let selected = false,
            disabledContactsNoGroup = _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts)),
            selectedContactsNoGroup = _.size(_.intersection(this.options.addressBookView.selectedContactsNoGroup, row.noGroupContacts)),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
            selected = selected || ((disabledContactsNoGroup + selectedContactsNoGroup + disabledGroups + selectedGroups) > 0);
        } else
            selected = selected || (_.size(_.intersection(this.options.addressBookView.selectedContactsAll, row.selectableContacts)) > 0);

        return selected;
    },
    isCompanyIndeterminate: function (row) {
        let indeterminate = false,
            isSelected = this.isCompanySelected(row),
            selectableContacts = _.size(row.selectableContacts),
            selectedContacts = _.size(_.intersection(this.options.addressBookView.selectedContactsAll, row.selectableContacts)),
            contactsNoGroup = _.size(row.noGroupContacts),
            disabledContactsNoGroup = _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts)),
            selectedContactsNoGroup = _.size(_.intersection(this.options.addressBookView.selectedContactsNoGroup, row.noGroupContacts)),
            contactGroups = _.size(row.contactGroups),
            disabledGroups = _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)),
            selectedGroups = _.size(_.intersection(this.options.addressBookView.selectedContactGroups, row.contactGroups));

        if (isSelected) {
            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {

                if (contactsNoGroup === 0 && contactGroups > 0) {
                    indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups);
                } else if (contactsNoGroup > 0 && contactGroups === 0) {
                    indeterminate = indeterminate || (contactsNoGroup > disabledContactsNoGroup + selectedContactsNoGroup);
                } else if (contactsNoGroup > 0 && contactGroups > 0) {
                    indeterminate = indeterminate || (contactGroups > disabledGroups + selectedGroups) || (contactsNoGroup > disabledContactsNoGroup + selectedContactsNoGroup);
                }
            } else {
                indeterminate = indeterminate || (selectedContacts > 0 && (selectableContacts > selectedContacts));
            }
        }

        return indeterminate;
    },
    isCompanyDisabled: function (row) {
        let disabled = false;
        if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {

            let allNoGroupContactsDisabled = _.size(row.noGroupContacts) === 0 || (_.size(row.noGroupContacts) === _.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.noGroupContacts))),
                allContactGroupsDisabled = _.size(row.contactGroups) === 0 || (_.size(row.contactGroups) === _.size(_.intersection(this.options.addressBookView.options.disabledContactGroups, row.contactGroups)));

            disabled = allContactGroupsDisabled && allNoGroupContactsDisabled;

        } else {
            disabled = (_.size(_.intersection(this.options.addressBookView.options.disabledContacts, row.selectableContacts)) === _.size(row.selectableContacts));
        }

        return disabled;
    },
    renderCompanySelect: function (data, type, row) {
        let isSelected = this.isCompanySelected(row.attributes),
            isIndeterminate = this.isCompanyIndeterminate(row.attributes),
            isDisabled = this.isCompanyDisabled(row.attributes);

        return ('<div class="text-align-center"><div class="pretty p-default p-icon p-smooth p-has-indeterminate fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected && !isIndeterminate ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + (isIndeterminate ? ' indeterminate ' : '') + ' class="select-company' + (isIndeterminate ? ' indeterminate ' : '') + '" />' +
            '<div class="state"><i class="icon far fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '<div class="state p-is-indeterminate"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '</div></div>');
    },
    updateCompanySelect: function (row) {
        let selectedCompanyContacts = _.intersection(this.options.addressBookView.selectedContactsAll, row.data().get('selectableContacts')),
            isSelected = this.isCompanySelected(row.data().attributes),
            isIndeterminate = this.isCompanyIndeterminate(row.data().attributes),
            isDisabled = this.isCompanyDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');
        if (isIndeterminate)
            $cb.prop('checked', false).prop('indeterminate', true).addClass('indeterminate');
        else if (isSelected)
            $cb.prop('checked', true).prop('indeterminate', false).removeClass('indeterminate');
        else
            $cb.prop('checked', false).prop('indeterminate', false).removeClass('indeterminate');
    },
    companySelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            row = this.getRow(tr);
        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsAll(row.data().get('selectableContacts'));

            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                this.options.addressBookView.addSelectedContactsNoGroup(row.data().get('noGroupContacts'));
                this.options.addressBookView.addSelectedContactGroups(row.data().get('contactGroups'));
            }
        } else {
            this.options.addressBookView.removeSelectedContactsAll(row.data().get('selectableContacts'));
            if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                this.options.addressBookView.removeSelectedContactsNoGroup(row.data().get('noGroupContacts'));
                this.options.addressBookView.removeSelectedContactGroups(row.data().get('contactGroups'));
            }
        }

        this.updateCompanySelect(row);

        // todo: cascade down to contacts / etc
        _.each(this.options.childDataTables, _.bind(function (childDT) {
            if (childDT.options.parentId === row.data().get('contactId')) {
                _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                    childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));

                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                        this.options.view === PJQ.constants.addressBook.view.COMPANY) {
                        _.each(childDT.options.childDataTables, _.bind(function (childDTchild) {
                            _.each(childDTchild.$el.find('.select-contactgroup'), _.bind(function (input) {
                                childDTchild.updateContactGroupSelect(childDTchild.getRow($(input).closest('tr')));
                            }, this));
                        }, this));
                    }
                }, this));
            }
        }, this));
    },
    showRowGroups: function (e) {
        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr')),
            data = row.data(),
            groups = data.get('groupListDisplay').split(',')
        target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
    },
    companySelectAllChanged: function (e) {
        let callback = _.bind(function () {
            _.each(this.$el.find('.select-company'), _.bind(function (input) {
                this.updateCompanySelect(this.getRow($(input).closest('tr')));
            }, this));

            _.each(this.options.childDataTables, _.bind(function (childDT) {
                _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                    childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));

                    if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT &&
                        this.options.view === PJQ.constants.addressBook.view.COMPANY) {
                        _.each(childDT.options.childDataTables, _.bind(function (childDTchild) {
                            _.each(childDTchild.$el.find('.select-contactgroup'), _.bind(function (input) {
                                childDTchild.updateContactGroupSelect(childDTchild.getRow($(input).closest('tr')));
                            }, this));
                        }, this));
                    }
                }, this));
            }, this));
        }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // loop through our data, add everyone, and update the checkboxes.
            let contacts = [], contactsNoGroup = [], contactGroups = [];
            _.each(this.$el.find('.select-company'), _.bind(function (input) {
                let row = this.getRow($(input).closest('tr'));
                $.merge(contacts, row.data().get('selectableContacts'));
                $.merge(contactsNoGroup, row.data().get('noGroupContacts'));
                $.merge(contactGroups, row.data().get('contactGroups'));
            }, this));
            if ($(e.currentTarget).prop('checked')) {
                this.options.addressBookView.addSelectedContactsAll(contacts);
                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup);
                    this.options.addressBookView.addSelectedContactGroups(contactGroups);
                }
            } else {
                this.options.addressBookView.removeSelectedContactsAll(contacts);
                if (this.options.addressBookView.options.selectionMode === PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT) {
                    this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup);
                    this.options.addressBookView.removeSelectedContactGroups(contactGroups);
                }
            }

            callback();
        }
    }
});

PJQ.views.addressbook.GroupHeaderDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click i.group-toggle-row': 'childRowToggle',
        'click .select-all-trades': 'tradeSelectAllChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['groupDescription', 'groupName', 'groupCount', 'childCount'];

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings.columnsDefault;

            columns.push({
                "columnData": "groupChildren",
                "data": null,
                "title": this.options.isShowCheckboxes ? '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="' + (this.options.parentDataTable ? 'select-all-trades-division' : 'select-all-trades') + '" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>' : '',
                "orderable": false,
                "searchable": false,
                "width": "30px",
                "defaultContent": '',
                "render": _.bind(function (data, type, row) {
                    let html = '';
                    if (this.options.settings.showGroupDescription)
                        html = '<i class="fal fa-plus-circle group-toggle-row" data-type="groupDescription" data-id="' + row.get('groupDescription') + '"></i>';
                    else
                        html = '<i class="fal fa-plus-circle group-toggle-row" data-type="groupId" data-id="' + row.get('groupId') + '"></i>';

                    return html;
                }, this)
            });

            columns.push({
                "columnData": "sortOrder",
                "data": "attributes.sortOrder",
                "searchable": false,
                "defaultContent": '',
                "visible": false
            });

        }

        let maxEmailWidth = $(window).width() > 1200 ? 225 : 100;
        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": "attributes.groupName",
                        "width": "40%",
                        "title": "Trade",
                    });
                    break;
                case 'groupDescription':
                    columns.push({
                        "columnData": "groupDescription",
                        "data": "attributes.groupDescription",
                        "width": "40%",
                        "title": "Division",
                    });
                    break;
                case 'childCount':
                    columns.push({
                        "columnData": "childCount",
                        "data": "attributes.childCount",
                        "title": (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? "Companies" : "Contacts"
                    });
                    break;
                case 'groupCount':
                    columns.push({
                        "columnData": "groupCount",
                        "data": "attributes.groupCount",
                        "width": "150px",
                        "title": "Trades"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    getChildTableType: function () {
        let view = '';
        if (this.options.settings.showGroupDescription)
            view = this.options.view + '-group';
        else {
            switch (this.options.view) {
                case PJQ.constants.addressBook.view.TRADES_COMPANY:
                case PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP:
                    view = PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY;
                    break;
                case PJQ.constants.addressBook.view.TRADES_CONTACT:
                case PJQ.constants.addressBook.view.TRADES_CONTACT_GROUP:
                    view = PJQ.constants.addressBook.view.TRADES_CONTACT_CONTACT;
                    break;
            }
        }
        return view;
    },
    getChildTableSettings: function () {
        return this.options.addressBookView.settings.getSettings(this.getChildTableType());
    },
    getRowChildTable: function (childOpts) {
        childOpts.view = this.getChildTableType();
        childOpts.settings = this.getChildTableSettings();
        childOpts.userSettings = this.options.userSettings;
        childOpts.addressBookView = this.options.addressBookView;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        childOpts.onApprove = this.options.onApprove;
        childOpts.isShowCheckboxes = this.options.addressBookView.isShowCheckboxes;
        childOpts.beforeDataTableRender = this.options.beforeDataTableRender;

        let result = null;
        if (this.options.settings.showGroupDescription)
            result = new PJQ.views.addressbook.GroupHeaderChildDataTable(childOpts);
        else
            result = (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? new PJQ.views.addressbook.CompanyDataTable(childOpts) : new PJQ.views.addressbook.ContactDataTable(childOpts);

        return result;
    },
    getRowChildData: function (row) {
        let view = (this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY || this.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_GROUP) ? "company" : "contact";
        if (this.options.settings.showGroupDescription)
            view = this.options.view;

        let viewOptions = {
            view: view,
            groupId: this.options.settings.showGroupDescription ? null : row.data().get('groupId'),
            groupDescription: this.options.settings.showGroupDescription && row.data() ? row.data().get('groupDescription') : null
        };
        return new PJQ.collections.addressBook.AddressBookViewResults(null, viewOptions);
    },
    tradeSelectAllChanged: function (e) {
        let processViews = _.bind(function (childDT) {
                if (childDT.options.view === PJQ.constants.addressBook.view.TRADES_COMPANY_COMPANY) {

                    _.each(childDT.$el.find('.select-company'), _.bind(function (input) {
                        childDT.updateCompanySelect(childDT.getRow($(input).closest('tr')));
                    }, this));

                    _.each(childDT.options.childDataTables, _.bind(function (contactDT) {
                        _.each(contactDT.$el.find('.select-contact'), _.bind(function (input) {
                            contactDT.updateContactSelect(contactDT.getRow($(input).closest('tr')));
                        }, this));
                    }, this));
                } else {
                    _.each(childDT.$el.find('.select-contact'), _.bind(function (input) {
                        childDT.updateContactSelect(childDT.getRow($(input).closest('tr')));
                    }, this));
                }
            }, this),
            callback = _.bind(function () {
                if (this.options.settings.showGroupDescription) {
                    _.each(this.options.childDataTables, _.bind(function (tradeDT) {
                        _.each(tradeDT.options.childDataTables, _.bind(function (childDT) {
                            processViews(childDT);
                        }, this));
                    }, this));
                } else {
                    _.each(this.options.childDataTables, _.bind(function (childDT) {
                        processViews(childDT);
                    }, this));
                }
            }, this);

        if (this.getIsRootView()) {
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), null, _.bind(function () {
                callback();
            }, this));
        } else {
            // showGroupDescription is ON, so we must figure out only the contacts with this groupDescription.
            this.options.addressBookView.selectAll($(e.currentTarget).prop('checked'), this.options.parentId, _.bind(function () {
                callback();
            }, this));
        }
    }
});

PJQ.views.addressbook.GroupHeaderChildDataTable = PJQ.views.addressbook.GroupHeaderDataTable.extend({
    events: {
        'click i.group-toggle-row': 'childRowToggle',
        'click .select-all-trades-division': 'tradeSelectAllChanged'
    }
});

PJQ.views.addressbook.ContactGroupDataTable = PJQ.views.addressbook.AddressBookDataTable.extend({
    events: {
        'click .select-all-contactgroup': 'contactGroupSelectAllChanged',
        'click .select-contactgroup': 'contactGroupSelectChanged'
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['groupName'];

        if (!includeAllColumns) {
            columns.push({
                "columnData": '',
                "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contactgroup" /><div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(this.renderContactGroupSelect, this)
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'groupName':
                    columns.push({
                        "columnData": "groupName",
                        "data": "attributes.groupName",
                        "title": "Trade",
                        "orderable": false
                    });
                    break;
            }
        }, this));

        return columns;
    },
    isContactGroupSelected: function (row) {
        let selected = (this.options.addressBookView.options.disabledContactGroups.indexOf(row.contactGroupId) !== -1) ||
            (this.options.addressBookView.options.disabledContacts.indexOf(this.options.parentId) !== -1 && row.contactGroupId === 0) ||
            (this.options.addressBookView.selectedContactGroups.indexOf(row.contactGroupId) !== -1) ||
            (this.options.addressBookView.selectedContactsNoGroup.indexOf(this.options.parentId) !== -1);

        return selected;
    },
    isContactGroupDisabled: function (row) {
        let disabled = (this.options.addressBookView.options.disabledContacts.indexOf(this.options.parentId) !== -1 && row.contactGroupId === 0) ||
            (this.options.addressBookView.options.disabledContactGroups.indexOf(row.contactGroupId) !== -1);
        return disabled;
    },
    renderContactGroupSelect: function (data, type, row) {
        let isSelected = this.isContactGroupSelected(row.attributes),
            isDisabled = this.isContactGroupDisabled(row.attributes);

        let html = '<div class="text-align-center"><div class="pretty p-default p-icon p-smooth fs-18 m-0">' +
            '<input type="checkbox"' + (isSelected ? ' checked ' : '') + (isDisabled ? ' disabled ' : '') + ' class="select-contactgroup" />' +
            '<div class="state"><i class="icon fal fa-check fs-16"></i> <label class="wd-0">&nbsp;</label></div>' +
            '</div></div>';

        return (html);
    },
    updateContactGroupSelect: function (row) {
        let isSelected = this.isContactGroupSelected(row.data().attributes),
            isDisabled = this.isContactGroupDisabled(row.data().attributes),
            $cb = $(row.node()).find('div.pretty > input[type="checkbox"]');

        $cb.prop('checked', isSelected);
    },
    contactGroupSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentParentTR = parentTR.parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            parentParentRow = this.options.parentDataTable && this.options.parentDataTable.options.parentDataTable ? this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR) : null;

        if ($(e.currentTarget).prop('checked')) {

            if (row.data().get('contactGroupId') > 0)
                this.options.addressBookView.addSelectedContactGroups([row.data().get('contactGroupId')]);
            else
                this.options.addressBookView.addSelectedContactsNoGroup([this.options.parentId]);
        } else {
            if (row.data().get('contactGroupId') > 0)
                this.options.addressBookView.removeSelectedContactGroups([row.data().get('contactGroupId')]);
            else
                this.options.addressBookView.removeSelectedContactsNoGroup([this.options.parentId]);
        }

        // cascade up to parents
        if (this.options.parentDataTable && parentRow) {
            this.options.parentDataTable.updateContactSelect(parentRow);
            if ([PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.parentDataTable.options.view) !== -1) {
                // find company view that owns the contact view, and update THAT
                this.options.parentDataTable.options.parentDataTable.updateCompanySelect(parentParentRow);
            }
        }
    },
    contactGroupSelectAllChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            parentTR = $(e.currentTarget).closest('tr').parent().closest('tr').prev(),
            parentParentTR = parentTR.parent().closest('tr').prev(),
            row = this.getRow(tr),
            parentRow = this.options.parentDataTable ? this.options.parentDataTable.getRow(parentTR) : null,
            parentParentRow = this.options.parentDataTable && this.options.parentDataTable.options.parentDataTable ? this.options.parentDataTable.options.parentDataTable.getRow(parentParentTR) : null,
            contactsNoGroup = [],
            contactGroups = [];

        // loop through our data, add everyone, and update the checkboxes.
        _.each(this.$el.find('.select-contactgroup'), _.bind(function (input) {
            let row = this.getRow($(input).closest('tr'));
            if (row.data().get('contactGroupId') === 0)
                contactsNoGroup.push(this.options.parentId);
            else
                contactGroups.push(row.data().get('contactGroupId'));
        }, this));

        if ($(e.currentTarget).prop('checked')) {
            this.options.addressBookView.addSelectedContactsNoGroup(contactsNoGroup);
            this.options.addressBookView.addSelectedContactGroups(contactGroups);
        } else {
            this.options.addressBookView.removeSelectedContactsNoGroup(contactsNoGroup);
            this.options.addressBookView.removeSelectedContactGroups(contactGroups);
        }

        _.each(this.$el.find('.select-contactgroup'), _.bind(function (input) {
            this.updateContactGroupSelect(this.getRow($(input).closest('tr')));
        }, this));

        if (this.options.parentDataTable && parentRow) {
            this.options.parentDataTable.updateContactSelect(parentRow);
            if ([PJQ.constants.addressBook.view.COMPANY_CONTACT].indexOf(this.options.parentDataTable.options.view) !== -1) {
                // find company view that owns the contact view, and update THAT
                this.options.parentDataTable.options.parentDataTable.updateCompanySelect(parentParentRow);
            }
        }
    }
});
